export const rules = {
  date: v => /^-?[\d]+\/[0-1]\d\/[0-3]\d$/.test(v) || "This field must be a valid date",
  time: v => /^([0-1]?\d|2[0-3]):[0-5]\d$/.test(v) || "This field must be a valid time",
  email: v => /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(v) || "This field must be a valid email",
  mustBeZero: v => v == 0 || "This field must equal zero.",
  uei: (v) => (v).length == 12 || "Your UEI should be 12 characters.",
  required: v => (!!v || v === 0) || "This field is required",
}